angular.module('bmsApp.sm.job')
	.controller('SMJobIndexCtrl', [
		'$log',
		'$state',
		'$scope',
		'SMJobSvc',
		'LicenseOptionsSvc',
		'$cookies',
		'$localStorage',
		'ngTableParams',
		'InstanceSvc',
		'$q',
		function ($log,
				  $state,
				  $scope,
				  SMJobSvc,
				  LicenseOptionsSvc,
				  $cookies,
				  $localStorage,
				  ngTableParams,
				  InstanceSvc,
				  $q) {

			var defaultTableParams = function () {
				return {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						id: 'desc' // initial sorting
					},
					filter: {
						search: '',
						converted: true,
						closed: false,
						order_confirmed: true,
						licences: null,
						licenceType: null,
					}
				};
			};

			var initialIndexParams = function () {
				if (angular.isDefined($localStorage.smJobIndexParams)) {
					self.searchText = $localStorage.smJobIndexParams.filter.search;
					return angular.extend({}, defaultTableParams(), $localStorage.smJobIndexParams);
				}
				else {
					return angular.extend({}, defaultTableParams());
				}
			};

			function init() {
				self.ecomEnabled = InstanceSvc.instance.ecomEnabled();
				var promises = {
					licenseOptions: LicenseOptionsSvc.license(),
					licenceTypeOptions: LicenseOptionsSvc.network(),
				};
				$q.all(promises)
					.then(function (response) {
						$scope.licenseOptions = response.licenseOptions.data.options;
						$scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
						$scope.loading = false;
					});

				var params = initialIndexParams();
				self.jobFilters = angular.copy(params.filter);

				self.tableParams = new ngTableParams(params, {
					total: 0, // length of data
					counts: $scope.config.table.settings.counts, // available page counts
					getData: function ($defer, params) {
						SMJobSvc.index(params.$params)
							.then(function (response) {
								params.total(response.data.sm_job_filtered_count);
								$defer.resolve(response.data.sm_job_collection);
								$scope.$emit('jobIndexUpdated', {
									job_collection: response.data.sm_job_collection,
									job_filtered_count: response.data.sm_job_filtered_count,
									job_total_count: response.data.sm_job_total_count
								});
								// Check if we've exceeded our page size, if we have, go back
								if (response.data.sm_job_total_count > 0 && !response.data.sm_job_collection.length) {
									let newParams = angular.copy(self.tableParams.$params);
									newParams.page--;
									angular.extend(self.tableParams.$params, newParams);
								}
								self.loading = false;
							});
					}
				});
			}

			// text search
			function filterChanged() {
				self.tableParams.$params.filter.search = self.searchText;
			}

			// Store the table params whenever anything changes
			$scope.$watch(function() {
				return self.tableParams.$params;
			}, function(value) {
				if (angular.isObject(value)) {
					$localStorage.smJobIndexParams = value;
				}
			}, true);

			// $scope.$watch('tableParams.$params', function (value) {
			// 	if (angular.isObject(value)) {
			// 		$localStorage.smJobIndexParams = value;
			// 	}
			// }, true);

			// other filters
			function filterApply() {
				console.log(self.jobFilters);
				angular.extend(self.tableParams.$params.filter, angular.copy(self.jobFilters));
			}

			function filterReset() {
				angular.extend(self.tableParams.$params, defaultTableParams());
				angular.extend(self.jobFilters, defaultTableParams().filter);
			}

			function rowClicked(job) {
				$state.go('main.sm.job.index.view', {
					jobId: job.id
				});
			}

			$scope.$on('smJobIndexExport', function () {
				var params = angular.copy(self.tableParams.$params);
				SMJobSvc.export(params);
			});

			var self = $scope.SMJobIndexCtrl = {
				loading: true,
				methods: {
					init: init,
					filterChanged: filterChanged,
					filterApply: filterApply,
					filterReset: filterReset,
					rowClicked: rowClicked
				}
			};

		}
	]);
